import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class WaterTemperatureAttribute extends Sensor {
  public waterTemperatureChart: any;
  private waterTemperatureSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.waterTemperatureChart = null;
    this.waterTemperatureSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;

      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.waterTemperatureSensor, position);
      this.waterTemperatureSensor[position].push([timestamp, element.waterTemperature]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredWaterTemperature = this.waterTemperatureSensor.filter(series => series.length > 0);

    const positionNodeWaterTemperature = this.waterTemperatureSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.waterTemperatureChart = this.getConfigChar(
      'waterTemperature',
      this.getChartSeriesNewNode('Sensor', filteredWaterTemperature, positionNodeWaterTemperature),
      this.getRanges('waterTemperature'),
      this.getLimits('waterTemperature')
    );
  }

  public hasWaterTemperatureSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.waterTemperatureSensor.length &&
      this.waterTemperatureSensor[index].length > 0
    );
  }

  public getWaterTemperatureSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.waterTemperatureSensor.length) {
      const sensorData = this.waterTemperatureSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Temperatura Agua', value: 'waterTemperature' }
    ];
  }
}
